// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channelsearchwrapper[data-v-7a38c74a] {
  position: relative;
  height: 100%;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item {
  width: 100%;
  border-bottom: 1px solid var(--hor-line-color);
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item .item-media {
  margin-left: 6px;
  margin-right: 2px;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom {
  margin-bottom: -71px;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content {
  margin-bottom: 2px;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text {
  max-width: 184px;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text .item-header {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 184px;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text .htswrapper {
  max-width: none;
  white-space: unset;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text:first-child,
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text .list-item .item-after:first-child,
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text .list-item .item-link:first-child {
  margin-left: 4px;
  margin-right: 2px;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-after {
  margin-right: 4px;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .dateTimeItems {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  min-width: 74px;
  align-items: end;
}
.channelsearchwrapper .scroller[data-v-7a38c74a] .resize-observer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  pointer-events: none;
  display: block;
  overflow: hidden;
  opacity: 0;
}
.channelsearchwrapper .btnwrapper[data-v-7a38c74a] {
  display: flex;
  border-top: 1px solid var(--border-bottom-section);
  height: 54px;
  align-items: center;
  justify-content: center;
}
.channelsearchwrapper .btnwrapper .btn[data-v-7a38c74a] {
  width: 97%;
  height: 45px;
  color: var(--font-color);
  background-color: var(--list-item-bghover);
  border: none;
  outline: 0;
  margin: 0 auto;
}
.channelsearchwrapper .btnwrapper .btn[data-v-7a38c74a]:hover {
  opacity: 0.8;
}
.hor-line[data-v-7a38c74a] {
  height: 1px;
  background: var(--hor-line-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/SearchInChannel.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,kDAAkD;EAClD,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,0CAA0C;EAC1C,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,iCAAiC;AACnC","sourcesContent":[".channelsearchwrapper[data-v-7a38c74a] {\n  position: relative;\n  height: 100%;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item {\n  width: 100%;\n  border-bottom: 1px solid var(--hor-line-color);\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item .item-media {\n  margin-left: 6px;\n  margin-right: 2px;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom {\n  margin-bottom: -71px;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content {\n  margin-bottom: 2px;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text {\n  max-width: 184px;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text .item-header {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 184px;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text .htswrapper {\n  max-width: none;\n  white-space: unset;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text:first-child,\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text .list-item .item-after:first-child,\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-content .item-text .list-item .item-link:first-child {\n  margin-left: 4px;\n  margin-right: 2px;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .item-after {\n  margin-right: 4px;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .list-item.listItemCustom .dateTimeItems {\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  min-width: 74px;\n  align-items: end;\n}\n.channelsearchwrapper .scroller[data-v-7a38c74a] .resize-observer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  border: none;\n  background-color: transparent;\n  pointer-events: none;\n  display: block;\n  overflow: hidden;\n  opacity: 0;\n}\n.channelsearchwrapper .btnwrapper[data-v-7a38c74a] {\n  display: flex;\n  border-top: 1px solid var(--border-bottom-section);\n  height: 54px;\n  align-items: center;\n  justify-content: center;\n}\n.channelsearchwrapper .btnwrapper .btn[data-v-7a38c74a] {\n  width: 97%;\n  height: 45px;\n  color: var(--font-color);\n  background-color: var(--list-item-bghover);\n  border: none;\n  outline: 0;\n  margin: 0 auto;\n}\n.channelsearchwrapper .btnwrapper .btn[data-v-7a38c74a]:hover {\n  opacity: 0.8;\n}\n.hor-line[data-v-7a38c74a] {\n  height: 1px;\n  background: var(--hor-line-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
